import {
  useDropdown
} from "@/common/hooks/useDropdown"
import {
  useAppContext
} from "@/context/app"
import {
  usePathname
} from "next/navigation"
import {
  useCallback, useEffect
} from "react"

export const useHeader = () => {

  const [ , {
    closeDrawer 
  }] = useAppContext()

  const [{
    hasBeenOffline, isOnline, isPageLoading 
  }] = useAppContext()
  const pathname = usePathname()

  const {
    elementRef: searchRef,
    expanded: isSearchOpen,
    setExpanded: setIsSearchOpen,
    triggerRef: searchTriggerRef,
  } = useDropdown()

  useEffect(() => {
    setIsSearchOpen(false)
  }, [pathname, setIsSearchOpen])

  const handleSearchTriggerClick = useCallback(() => {
    closeDrawer()
    setIsSearchOpen((isOpen) => !isOpen)
  }, [closeDrawer, setIsSearchOpen])

  return {
    handleSearchTriggerClick,
    hasBeenOffline,
    isOnline,
    isPageLoading,
    isSearchOpen,
    setIsSearchOpen,
    searchRef,
    searchTriggerRef,
  }
}
